export const getPunycodeDomain = (hostname: string) => {
    try {
        return new URL(`https://${hostname}`).hostname;
    } catch {
        return hostname;
    }
};
